import { css as r } from "@microsoft/fast-element";
import { normalize as i } from "../../common/normalize.js";
import { display as n, PropertyStyleSheetBehavior as a } from "@matrix42/fast-foundation";
import { typography as t } from "../../styles/typography.js";
import { designTokens as o } from "../../design-tokens.js";
function l(e) {
  return new a("active", !0, e);
}
const c = (e) => r`
  .control {
    /* Style */
    color: ${o.color.primary[100]};
    background-color: ${o.color.white};
  }

  .control .content-wrapper {
    /* Typography */
    ${t("p", "semibold")}
  }

  .control .content-wrapper ${e.prefix}-icon {
    /* Style */
    color: ${o.color.primary[100]};
  }
`, m = (e) => r`
    ${i}
    ${n("flex")}
    .control {
      /* Base */
      width: 100%;
      min-height: ${o.spacing[9]};
      /* Layout */
      display: flex;
      flex-direction: column;
      /* Style */
      color: ${o.color.neutral[100]};
      /* Typography */
      ${t("p", "regular")}
      white-space: nowrap;
    }

    ::slotted(${e.prefix}-icon) {
      /* Base */
      min-width: ${o.iconSize.sm};
      width: ${o.iconSize.sm} !important;
      height: ${o.iconSize.sm} !important;
    }

    .content-wrapper {
      /* Base */
      width: 100%;
      height: ${o.spacing[10]};
      padding: ${o.spacing["2.5"]} ${o.spacing[2]}
        ${o.spacing["2.5"]} ${o.spacing[4]};
      /* Layout */
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: ${o.spacing[2]};
    }

    .items {
      /* Layout */
      display: flex;
      flex-direction: column;
      padding: ${o.spacing[2]} 0;
      /* Style */
      color: ${o.color.neutral[100]};
    }

    .divider {
      /* Base */
      height: ${o.borderWidth.xs};
      width: calc(100% - ${o.spacing[4]});
      margin: 0 ${o.spacing[2]};
      /* Layout */
      display: flex;
      /* Style */
      background-color: ${o.color.neutral[50]};
    }

    .control ${e.prefix}-icon {
      /* Base */
      flex-shrink: 0;
      /* Style */
      color: ${o.color.neutral[100]};
    }

    .content-wrapper:hover {
      /* Base */
      cursor: pointer;

      /* Style */
      background-color: ${o.color.primary[40]};
      color: ${o.color.primary[200]};
    }

    .content-wrapper:hover ${e.prefix}-icon {
      /* Style */
      color: ${o.color.primary[200]};
    }

    .hidden {
      /* Base */
      display: none;
    }

    .content {
      /* Base */
      flex-grow: 1;
      /* Style */
      overflow: hidden;
      text-overflow: ellipsis;
    }
  `.withBehaviors(l(c(e)));
export {
  m as navItemStyles
};
